import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyAutocompleteModule as MatAutocompleteModule } from '@angular/material/legacy-autocomplete';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { RouterModule } from '@angular/router';

import { TranslocoModule } from '@jsverse/transloco';

import { SearchInputComponent } from './components/search-input/search-input.component';

import { TranslateContentPipeModule } from '../../../../../shared/pipes/translate-content/translate-content-pipe.module';
import { TranslateCountryPipeModule } from '../../shared/pipes/translate-country/translate-country-pipe.module';
import { ActivityPreviewModule } from '../activity-preview/activity-preview.module';
import { ProfileLogoModule } from '../profile-logo/profile-logo.module';

/**
 * Widget module for Page Not Found - 404
 */
@NgModule({
  imports: [
    // **** Angular modules ****
    CommonModule,
    ReactiveFormsModule,
    RouterModule,

    // *** 3th party modules ***
    MatAutocompleteModule,
    MatIconModule,
    MatInputModule,
    TranslocoModule,

    // *** SmartHead modules ***
    ActivityPreviewModule,
    ProfileLogoModule,
    TranslateContentPipeModule,
    TranslateCountryPipeModule
  ],
  declarations: [SearchInputComponent],
  exports: [SearchInputComponent]
})
export class SearchInputModule {}
